import mobileMenu from "../../../assets/general/mobile-menu.svg";
import mobileMenuSelected from "../../../assets/general/mobile-menu-selected.svg";

interface MobileMenuToggleProps {
  isOpen: boolean;
  onToggle: () => void;
}

export function MobileMenuToggle({ isOpen, onToggle }: MobileMenuToggleProps) {
  return (
    <button
      className="mobile-menu-selector"
      onClick={onToggle}
      aria-label="Toggle menu"
      style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
    >
      <img
        src={isOpen ? mobileMenuSelected : mobileMenu}
        alt={isOpen ? "Close Menu" : "Open Menu"}
      />
    </button>
  );
}
